// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__wliYd","purple":"Button_purple__Sxlcm","outlined":"Button_outlined__JFj4e","filed":"Button_filed__vHzmJ","empty":"Button_empty__NCug7"};